import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';

import { cardCss } from './InquiryItem';

interface Props {
    count?: number;
}

function InquiryItemSkeletons({ count = 3 }: Props) {
    return (
        <Column fullWidth spacing={4} aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <InquiryItemSkeleton key={`inquiry-item-sk-${idx}`} />
            ))}
        </Column>
    );
}

function InquiryItemSkeleton() {
    return (
        <div css={cardCss}>
            <Row spacing={2}>
                <Skeleton width={48} height={22} />
                <Skeleton width={56} height={14} />
            </Row>
            <Skeleton width='50%' height={22} />
            <Column fullWidth>
                <Skeleton height={20} />
                <Skeleton width='70%' height={20} />
            </Column>
        </div>
    );
}

export default InquiryItemSkeletons;
